export default __webpack_public_path__ + "static/media/cu.2bdff072.svg";